export default __webpack_public_path__ + "static/gold-b21d452a957ddc189d05cda98ce64a6e.png";